const siteHeaderEl = document.querySelector('.site-header');
const headerNavEl = siteHeaderEl.querySelector('.site-header__nav');

// Toggla menyn
document.querySelector('.site-header__nav-toggle').addEventListener('click', e => {
    document.body.classList.toggle('stop-scrolling');
    siteHeaderEl.classList.toggle('site-header--menu-open');
    document.body.classList.toggle('sub-menu-open');

    const hidden = headerNavEl.getAttribute('aria-hidden');
    headerNavEl.setAttribute('aria-hidden', hidden === 'true' ? 'false' : 'true');


    let elem = document.querySelector('main');
    if(elem) {
        if(hidden === 'true') {
            elem.classList.add('blurred');
        } else {
            elem.classList.remove('blurred');
        }
    }


});

if(!document.body.classList.contains('single-erbjudande')) {
    const htmlEl = document.querySelector('html');
    const headerDocker = () => {
        const scroll = htmlEl.scrollTop;

        if (scroll >= 100) {
            document.body.classList.add('shrink');
        } else {
            document.body.classList.remove('shrink');
        }
        if (scroll >= 200) {
            document.body.classList.add('scrolled');
        } else {
            document.body.classList.remove('scrolled');
        }

        var percent = (scroll / 600);
        if(percent <= 1) {
            document.querySelector('#header .bg').style.opacity = percent;
            if(document.querySelectorAll('.page-sub-menu').length > 0) {
                document.querySelector('.page-sub-menu .bg').style.opacity = percent;
            }
        } else {
            if(document.querySelector('#header .bg').style.opacity != '1') {
                document.querySelector('#header .bg').style.opacity = '1';
                if(document.querySelectorAll('.page-sub-menu').length > 0) {
                    document.querySelector('.page-sub-menu .bg').style.opacity = '1';
                }
            }
        }
    };
    document.addEventListener('scroll', headerDocker, { capture: false, passive: true });
}
if(window.screen.width > 1024) {
    document.querySelector('#header').addEventListener('mouseenter', function(){
        document.querySelector('#header .bg').style.opacity = "1";
    });

    document.querySelector('#header').addEventListener('mouseleave', function(){
        document.querySelector('#header .bg').style.opacity = "0";
    });
    document.querySelectorAll('.menu-item-has-children.d-0').forEach(item => {
        const hooverEvent = e => {
            if(document.querySelector('.sub-menu.visible')) {
                document.body.classList.remove('sub-menu-open');
                headerNavEl.setAttribute('aria-hidden', 'false');
                document.querySelector('.sub-menu.visible').classList.remove('visible');
            }


            document.body.classList.add('sub-menu-open');
            headerNavEl.setAttribute('aria-hidden', 'true');

            item.querySelector('.sub-menu').classList.add('visible');

            let main = document.querySelector('main');
            if(main) {
                main.classList.add('blurred');
            }

            let footer = document.querySelector('#footer');
            if(!footer) {
                footer = document.querySelector('#footer-block');
            }
            footer.classList.add('blurred');
        };
        item.addEventListener('mouseenter', hooverEvent);
        item.querySelector('a').addEventListener('focus', hooverEvent);
    })

    document.querySelectorAll('.menu-item-has-children.d-0').forEach(item => {
        const hooverEvent = e => {
            document.body.classList.remove('sub-menu-open');
            headerNavEl.setAttribute('aria-hidden', 'false');

            item.querySelector('.sub-menu').classList.remove('visible');
            let main = document.querySelector('main');
            if(main) {
                main.classList.remove('blurred');
            }

            let footer = document.querySelector('#footer');
            if(!footer) {
                footer = document.querySelector('#footer-block');
            }
            footer.classList.remove('blurred');
        };
        item.addEventListener('mouseleave', hooverEvent);
    })
} else {
    document.querySelectorAll('.menu-item-has-children').forEach(item => {
        item.querySelector('.grow').addEventListener('click', e => {
            const sub = item.querySelector('.sub-menu');
            if(sub.style.display === "block") {
                sub.style.display = "none"
            } else {
                sub.style.display = "block"
            }
            e.srcElement.parentElement.classList.toggle('open')
        })
    });
    document.querySelectorAll('.menu-item-has-children.d-2').forEach(item => {
        const target = item.parentElement.parentElement;
        const parent = item.parentElement;
        // item.insertAfter(target);
        target.parentElement.insertBefore(item, target.nextSibling);
        item.classList.remove('d-2');
        item.classList.add('d-1');
        item.querySelector('.sub-menu.menu-depth-3').classList.add('menu-depth-2');
        item.querySelector('.sub-menu.menu-depth-3').classList.remove('menu-depth-3');
    });
    document.querySelectorAll('.sub-menu.menu-depth-2').forEach(item => {
        if(item.querySelectorAll('li').length === 0) {
            item.remove();
        }
    })
    document.querySelectorAll('.menu-item-has-children.small').forEach(item => {
        const target = item.querySelector('.sub-menu');
        target.querySelectorAll('li').forEach(sub => {
            item.parentElement.insertBefore(sub, item.nextSibling);
        });
        item.classList.remove('menu-item-has-children');
    })
}
